/**
 *
 * File: UnitsRequest.js
 *
 */
(function () {
    angular
        .module('maApp.remoteRequests')
        .factory('UnitsRequest', UnitsRequest);

    UnitsRequest.$inject = ['$http', '$interpolate', 'endpoint', 'Auth', 'RequestError'];

    function UnitsRequest($http, $interpolate, endpoint, Auth, RequestError) {

        return {
            get: fetchProjectUnits
        };

        function fetchProjectUnits(projectId) {
            var templateUrl = "{{endpoint}}samplingunits/?dataonly=1&samplingunittypes=55&project={{projectId}}&fields={{fields}}&{{auth}}";
            var templateOptions = {
                'endpoint': endpoint,
                'projectId': projectId,
                'fields':"id,name,fullname,area",
                'auth': Auth.getUserAuthQueryStr()
            };
            return $http.get($interpolate(templateUrl)(templateOptions))
                .then(fetchSuccess, fetchFail);
            function fetchSuccess(response){
                return response.data;
            }
            function fetchFail(response){
                throw new RequestError(response, 'Failed to read units');
            }

        }

    }
})();